<script>

    import { createEventDispatcher, onMount } from 'svelte';
    import tippy from "sveltejs-tippy";

    export let decodingInProgress;

    const presets = {
        'mumble': [
            ['blb', 'nas'],
            ['mid', 'cnt', 'unr', 'vwl'],
            ['blb', 'nas'],
            ['vcd', 'blb', 'stp'],
            ['mid', 'cnt', 'unr', 'vwl'],
            ['alv', 'lat'],
        ],
        'snoozed': [
            ['vls', 'alv', 'frc'],
            ['alv', 'nas'],
            ['hgh', 'bck', 'rnd', 'vwl'],
            ['vcd', 'alv', 'frc'],
            ['vcd', 'alv', 'stp'],
        ],
        'peekaboo': [
            ['vls', 'blb', 'stp'],
            ['hgh', 'fnt', 'unr', 'vwl'],
            ['vls', 'vel', 'stp'],
            ['mid', 'cnt', 'unr', 'vwl'],
            ['vcd', 'blb', 'stp'],
            ['hgh', 'bck', 'rnd', 'vwl']
        ],
        'widdershins': [
            ['lbv', 'apr'],
            ['smh', 'fnt', 'unr', 'vwl'],
            ['vcd', 'alv', 'stp'],
            ['umd', 'cnt', 'rzd', 'vwl'],
            ['vls', 'pla', 'frc'],
            ['smh', 'fnt', 'unr', 'vwl'],
            ['alv', 'nas'],
            ['vcd', 'alv', 'frc']
        ],
        'jabberwock': [
            ['vcd', 'alv', 'stp', 'frc'],
            ['low', 'fnt', 'unr', 'vwl'],
            ['vcd', 'blb', 'stp'],
            ['umd', 'cnt', 'rzd', 'vwl'],
            ['lbv', 'apr'],
            ['low', 'bck', 'unr', 'vwl'],
            ['vls', 'vel', 'stp']
        ],
        'nonsense': [
            ['alv', 'nas'],
            ['low', 'bck', 'unr', 'vwl'],
            ['alv', 'nas'],
            ['vls', 'alv', 'frc'],
            ['lmd', 'fnt', 'unr', 'vwl'],
            ['alv', 'nas'],
            ['vls', 'alv', 'frc'],
        ]
    }

    let selectedPreset = '[select]';

    const dispatch = createEventDispatcher();

    function randomize() {
        dispatch('randomize');
    }

    function preset() {
        if (selectedPreset != '[select]') {
            dispatch('preset', {featList: presets[selectedPreset]});
        }
    }

    export function reset() {
        selectedPreset = '[select]';
    }

</script>

<style>
    .control {
        text-align: center;
        text-transform: uppercase;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 0.8rem;
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        white-space: nowrap;
        margin-left: 0;
        margin-right: 0;
    }

    .control select {
        -webkit-appearance: none;
        appearance: none;
        margin-bottom: 0;
        margin-left: 0.5rem;
        width: 10em;
        cursor: pointer;
    }

    .control .select-wrapper {
        position: relative;
    }

    .control .select-wrapper::after {
        content: "▼";
        color: #e24;
        position: absolute;
        right: 1rem;
        top: 0.5rem;
        pointer-events: none; /* utterly bizarre that I have to do this */
    }
</style>

<div style="display: flex; justify-content: flex-end; margin: 0.5rem;">
    <div class="control box dark lev1" style="position: relative; left: 3rem;">
        <span use:tippy="{{content: 'Populate sequencer with sounds of an existing word.'}}">
            <div class="help">&nbsp;</div>&nbsp;Examples</span>
        <div class="select-wrapper"><select class="lev2 light-border light" bind:value={selectedPreset}
            on:blur={preset}
            on:change={preset}>
            <option>[select]</option>
            {#each Object.entries(presets) as ps}
                <option>{ps[0]}</option>
            {/each}
        </select></div>
    </div>
    <div class="control box light lev1" style="padding-left: 3rem;">
    
        <div class="control-pair" use:tippy="{{content: 'Fill tracks at random'}}">
            <button class="hovery"
                style="background-image: url(/assets/svg/_randomize-medium-red.svg);"
                id="randomize" title="Randomize"
                disabled={decodingInProgress}
                on:click={randomize}>&nbsp;</button>
            <label for="randomize">Randomize</label>
        </div>

    </div>
</div>
